import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// 提前应用主题，避免刷新页面时先闪一下白再变暗（light 默认 → dark → system 三态）
const _themeMode = localStorage.getItem('themeMode') || (localStorage.getItem('darkMode') === '1' ? 'dark' : 'light');
const _isDark = _themeMode === 'dark' || (_themeMode === 'system' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);
if (_isDark) {
  document.documentElement.setAttribute('data-theme', 'dark');
}

// 全局 fetch 包装：自动带上管理员 token；管理员请求返回 401 时清 token 并触发重新登录
const originalFetch = window.fetch.bind(window);
window.fetch = async (input, init = {}) => {
  const token = localStorage.getItem('adminToken');
  const hadToken = !!token;
  if (token) {
    const headers = new Headers(init.headers || {});
    headers.set('Authorization', `Bearer ${token}`);
    init = { ...init, headers };
  }
  const res = await originalFetch(input, init);
  const url = typeof input === 'string' ? input : (input && input.url) || '';
  const isLogin = url.includes('/api/users/login');
  if (res.status === 401 && hadToken && !isLogin) {
    localStorage.removeItem('adminToken');
    window.dispatchEvent(new CustomEvent('auth:expired'));
  }
  return res;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
